var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagUnitedStates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_7974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.75 75C58.4607 75 75.25 58.2107 75.25 37.5C75.25 16.7893 58.4607 0 37.75 0C17.0393 0 0.25 16.7893 0.25 37.5C0.25 58.2107 17.0393 75 37.75 75Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1196 37.5H75.25C75.25 34.1153 74.7988 30.8364 73.9582 27.7173H36.1196V37.5Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1196 17.9348H69.746C67.4504 14.1889 64.5153 10.8779 61.0932 8.1521H36.1196V17.9348Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7504 75C46.5759 75 54.6878 71.9497 61.0936 66.8479H14.4072C20.813 71.9497 28.9249 75 37.7504 75Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75415 57.0651H69.7461C71.5891 54.058 73.0183 50.7708 73.9583 47.2825H1.54199C2.48198 50.7708 3.91123 54.058 5.75415 57.0651Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6207 5.85615H21.038L17.8593 8.16548L19.0735 11.9021L15.895 9.59282L12.7164 11.9021L13.7652 8.67407C10.9665 11.0054 8.51348 13.7367 6.49199 16.7801H7.58696L5.56357 18.25C5.24834 18.7759 4.946 19.3102 4.65625 19.8523L5.62246 22.8261L3.81982 21.5164C3.37173 22.4657 2.96187 23.4365 2.59346 24.4274L3.65796 27.704H7.58696L4.40825 30.0133L5.62246 33.75L2.4439 31.4407L0.539893 32.8241C0.349316 34.356 0.25 35.9164 0.25 37.5H37.75C37.75 16.7895 37.75 14.3479 37.75 0C30.342 0 23.4363 2.14893 17.6207 5.85615ZM19.0735 33.75L15.895 31.4407L12.7164 33.75L13.9306 30.0133L10.7519 27.704H14.6809L15.895 23.9673L17.109 27.704H21.038L17.8593 30.0133L19.0735 33.75ZM17.8593 19.0894L19.0735 22.8261L15.895 20.5167L12.7164 22.8261L13.9306 19.0894L10.7519 16.7801H14.6809L15.895 13.0434L17.109 16.7801H21.038L17.8593 19.0894ZM32.5246 33.75L29.346 31.4407L26.1675 33.75L27.3817 30.0133L24.203 27.704H28.132L29.346 23.9673L30.5601 27.704H34.4891L31.3104 30.0133L32.5246 33.75ZM31.3104 19.0894L32.5246 22.8261L29.346 20.5167L26.1675 22.8261L27.3817 19.0894L24.203 16.7801H28.132L29.346 13.0434L30.5601 16.7801H34.4891L31.3104 19.0894ZM31.3104 8.16548L32.5246 11.9021L29.346 9.59282L26.1675 11.9021L27.3817 8.16548L24.203 5.85615H28.132L29.346 2.11948L30.5601 5.85615H34.4891L31.3104 8.16548Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_7974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUnitedStates);
export default __webpack_public_path__ + "static/media/flagUnitedStates.c6e8a1c6743aa6a4424562158eb86309.svg";
export { ForwardRef as ReactComponent };